import React from 'react'
import classnames from '@helpers/misc/classnames'
import isServerSide from '@helpers/misc/isServerSide'
import useIsDarkMode from '@hooks/useIsDarkMode'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import Logo from './Logo'
import LogoMX from './LogoMX'
import LogoNoText from './LogoNoText'

const aspectRatio = 780.4 / 224.7
const aspectRatioWide = 81 / 17

export function JustoLogoLoadingSkeleton({height = 20}: {height?: number}) {
  return (
    <div className="flex flex-col space-y-5 animate-pulse">
      <div className="flex flex-col space-y-2">
        <div
          style={{width: aspectRatio * height, height: height}}
          className="bg-gray-200 dark:bg-zinc-600 rounded"></div>
      </div>
    </div>
  )
}

export default function JustoLogo({
  height = 20,
  className,
  forceColor,
  noText = false
}: {
  height?: number
  className?: string
  forceColor?: 'black' | 'white'
  noText?: boolean
}) {
  const {viewerCountryCode} = useQuery({
    query: gql`
      query countryCodeJustoLogo {
        viewerCountryCode
      }
    `,
    omit: isServerSide() || noText,
    partial: true
  })

  let darkMode = useIsDarkMode()
  if (forceColor) {
    darkMode = forceColor !== 'black'
  }

  if (!viewerCountryCode && !noText) return <JustoLogoLoadingSkeleton height={height} />

  const CurrentLogo = noText ? LogoNoText : viewerCountryCode === 'MX' ? LogoMX : Logo

  return (
    <CurrentLogo
      className={classnames({
        'flex items-center': true,
        'text-black': !darkMode,
        'text-white': darkMode,
        [className]: className
      })}
      width={
        noText
          ? height
          : viewerCountryCode === 'MX'
          ? aspectRatioWide * height
          : aspectRatio * height
      }
      height={height}
    />
  )
}
